module.exports = __webpack_public_path__ + "static/media/facebook.d189caeb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/facebook.svg
// module id = 1788
// module chunks = 0